import React from 'react';
import {ContainerModal, Button} from './styles';

const SimpleModal = ({ onClose, children }) => {
  return (
    <ContainerModal>
      {children}
      <Button onClick={onClose}>
        Fechar
      </Button>
    </ContainerModal>
  );
};

export default SimpleModal;
